import { BansPopoverController } from './bansPopoverController';
export class BansController {
  constructor(parent, mapView, key, info) {
    this._parent = parent;
    this._key = key;
    this._mapView = mapView;
    this._info = info;
    this._tween = swim.Transition.duration(350);

    // Data
    this._lng = { value: info.get('lon').numberValue(0), dirty: true };
    this._lat = { value: info.get('lat').numberValue(0), dirty: true };
    this._rad = { value: 0, dirty: true };

    // Create Geofence on map
    this._geofence = new swim.MapCircleView()
      .center([this._lng.value, this._lat.value])
      .radius(10)
      .fill(swim.Color.transparent())
      .stroke(swim.Color.transparent())
      .strokeWidth(1);

    this._mapView.view.setChildView(`${this._key}-geofence`, this._geofence);

    // Create Marker on map
    this._marker = new swim.MapCircleView()
      .center([this._lng.value, this._lat.value])
      .radius(5)
      .fill(swim.Color.transparent());

    this._mapView.view.setChildView(`${this._key}-marker`, this._marker);
    this._marker.on("click", this.onClickVehicle.bind(this));

    this.update(info);
    this.init();
  }

  init() {
    const color = swim.Color.parse('#ff8c00');
    this._marker.fill(swim.Color.transparent());
    this._geofence.stroke(color);
  }

  update(info) {
    this._info = info;

    const lng = info.get('lon').numberValue(0);
    if(lng !==  this._lng.value) {
      this._lng.value = lng;
      this._lng.dirty = true;
    }
    const lat = info.get('lat').numberValue(0);
    if(lat !== this._lat.value) {
      this._lat.value = lat;
      this._lat.dirty = true;
    }

    const rad = info.get('rad').numberValue(0);
    if(rad !== this._rad) {
      this._rad.value = rad;
      // this._rad.value = 8.04672; // FIXME: Hard code 5 mile in km
      this._rad.dirty = true;
    }

    if(this._popoverView) { this._popoverView.update(this._info); }
  }

  render() {
    if(this._lng.dirty || this._lat.dirty) {
      this._marker.center([this._lng.value, this._lat.value], this._tween);
      this._geofence.center([this._lng.value, this._lat.value], this._tween);
      this._lng.dirty = false;
      this._lat.dirty = false;
    }

    if(this._rad.dirty) {
      const zoomLevel = this._mapView.map.getZoom();
      this.zoomUpdate(zoomLevel);
      this._rad.dirty = false;
    }

  }

  onClickVehicle(event) {
    event.stopPropagation();
    if (!this._popoverView) {
      this._popoverView = new BansPopoverController(this, this._marker, this._info);
    }
    this._mapView.appView.togglePopover(this._popoverView.view, {multi: event.altKey});
  }

  remove() {
    if(this._popoverView) {
      this._popoverView.view.remove();
      this._popoverView = null;
    }
    this._marker.remove();
    this._geofence.remove();
  }

  kmToPixel(latitude, km, zoomLevel) {
    const earthCircumference = 40075017;
    const latitudeRadians = latitude * (Math.PI/180);
    const metersPerPixel = earthCircumference * Math.cos(latitudeRadians) / Math.pow(2, zoomLevel + 8);
    const meter = km * 1000;

    return meter / metersPerPixel;
  }

  zoomUpdate(zoomLevel) {
    const r = this.kmToPixel(this._lat.value, this._rad.value,  zoomLevel);
    if(this._geofence) {
      this._geofence.radius(r, this._tween);
    }
  }
}
